import React from "react";
import logo from "./logo.jpeg";
import "./logo.scss";

export const Logo = () => {
  return <img className="logo" src={logo} alt="top score group logo" />;
};
